import { render } from "./competitor-settings.vue?vue&type=template&id=232bfdf8"
import script from "./competitor-settings.vue?vue&type=script&lang=js"
export * from "./competitor-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__